export const MAX_ITEMS = 500;

export const CATEGORY_LABELS = {
  refid: "Ref ID",
  cleanmd5: "Clean MD5",
};

// Fields shown in the Compare and View Data popups, in this order.
// Add or remove names here to change what is shown.
export const COMPARE_FIELDS = [
  "cleantxt",
  "cleanmd5",
  "multipart",
  "part",
  "bbmd5",
  "compsortmd5",
  "type",
  "status",
  "createdat",
  "lastmodified",
];

// Tables that name a field differently.
// { tableName: { field: actualColumnInThatTable } }
export const FIELD_ALIASES = {
  source: {
    cleantxt: "srctxt",
    cleanmd5: "txtmd5",
  },
};
